import { Injectable, signal, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  crumbsSignal = signal<string[]>(['Home']);
  crumbClick$ = new EventEmitter<string>();

  constructor() {}

  setCrumbs(crumbs: string[]) {
    this.crumbsSignal.set(crumbs);
  }

  emitClick(crumb: string) {
    this.crumbClick$.emit(crumb);
  }
}
